import { FC } from 'react';
// components
import BottleCapacityComponent from 'components/main/BottleCapacity/Edit';

const EditBottleCapacity: FC = () => <BottleCapacityComponent />;

export default EditBottleCapacity;
